import React from "react"
import MasterDetail from "../../../common/MasterDetail";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import {merge, optionsFor, select, updateExternalLinks} from "../../../common/commonHandlers";
import {bindActionCreators} from 'redux'
import createApiService from "../../../common/clientActionsBuilder";
import {connect} from "react-redux";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {ContentState, EditorState} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import ResourceComponent from "../../../components/ResourceComponent";
import Select from "react-select"
import {Jodit} from 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from "jodit-react";
import $ from "jquery";
import EmailEditorPreview from './EmailEditorPreview'

import * as EmailTemplatesActions from './EmailTemplatesApi'
import {JODIT_BUTTONS} from "../../../constants";
import {MaterialSwitch} from "../../../components/MaterialSwitch/MaterialSwitch";
import {Editor} from '@tinymce/tinymce-react';
import config from "../../../config/environment"
import {getClient, reportAiError, saveEditorSettings} from "../../../components/email/EmailEditorApi";
import _ from "lodash";
import {withMediaQuery} from '../../../utilities/hooks/useMediaQuery';


const api = createApiService('email_templates', 'email_template', 'Email template');
const actions = {...api, ...EmailTemplatesActions, reportAiError}

// "self.validate_shortcodes_for": "accessors"
const shortcodeOptions = {
    "payment": ['payment'],
    "payment failed": ['payment_failed'],
    "payment deposit": ['payment_deposit'],
    "invoice": ['invoice'],
    "invoice paid": ['invoice', 'invoice paid'],
    "issue": ['issue'],
    "proposal": ['proposal'],
    "sticky": ['sticky', 'proposal'],
    "scheduler event": ['scheduler_event', 'work_order', 'lead'],
    "email": ['email'],
    "bulk": ['proposal', 'work_order', 'scheduler_event'],
    "automatic email": ['email_automatic'],
    "fleet payment email": ['truck'],
    "briefing": ['user'],
    "lead duplicate": ['lead_duplicate'],
    "service priority": ['priority', 'recipient'],
    "service completed": ['ps'],
    "backlog": ['proposal', 'proposal_services'],
    "job completed": ['job'],
    "other (No validation)": []
}

const validateShortcodesOptions = Object.keys(shortcodeOptions).map(e => ({label: e, value: e}));

class EmailTemplates extends ResourceComponent {
    defaultValues = {name: '', from: '', reply_to: '', bcc: '', subject: '', message: ''};
    state = {};

   constructor(props) {
        super(props);

        const { isMobile } = props;

        this.joditConfig = {
            readonly: false,
            enter: 'div',
            disablePlugins: ["preview"],
            buttons: [
                ...Jodit.defaultOptions.buttons.filter(b => b.group !== "source" && b.group !== "preview"),
                {
                    name: 'source',
                    exec: (editor) => {
                        editor.selection.clear();
                        editor.selection.remove();
                        setTimeout(() => {
                            editor.setMode(editor.mode === 1 ? 2 : 1)
                        }, 100)
                    }
                },
                {
                    name: 'preview',
                    exec: () => this.setState({isPreviewModalOpened: true})
                },
            ],
            popup: {
                cells: [
                    ...JODIT_BUTTONS.advanced.popupButtons,
                    Jodit.defaultOptions.popup.cells[6],
                    Jodit.defaultOptions.popup.cells[7],
                    Jodit.defaultOptions.popup.cells[8]
                ]
            },
            minHeight: 500,
            width: isMobile ? (window.screen.width - 30) : null,
            colorPickerDefaultTab: "color",
            extraPlugins: ['tooltip'],
            showTooltipDelay: 0,
            askBeforePasteHTML: false,
            askBeforePasteFromWord: false,
            defaultActionOnPaste: "insert_only_text",
            uploader: {insertImageAsBase64URI: true}
        }

        this.state = {
            resource: {
                message: '',
            },
            isPreviewModalOpened: false,
            config: this.joditConfig,
            showHtmlModal: false,
            isJodit: false,
            initialValue: "",
            shortcodes: [],
            shortcodesLoading: true,
            availableEmails: [],
            emailErrors: {
                fromEmailError: null,
                reply_toEmailError: null,
                bccEmailError: null,
                ccEmailError: null
            }
        }
    }

    editorRef = React.createRef();
    wrapperRef = React.createRef()

    setRef = jodit => this.jodit = jodit;

    updateResources = resources => {
        this.setState({resources})
    };

    updateJoditConfig = () => {
        this.setState({
            config: {
                ...this.joditConfig,
                askBeforePasteHTML: this.state.showHtmlModal
            },
        });
    };

    componentDidMount = () => {
        this.props.actions.load({}, this.updateResources);
        this.props.actions.getTextMessageTemplates(res => {
            this.setState({textMessageTemplateOptions: res})
        })
        this.props.actions.getShortCodes((shortcodes) => {
            this.setState({shortcodes, shortcodesLoading: false})
        })

        if (this.props.clientId) {
            this.props.actions.getClient(this.props.clientId, (res) => {
                const parsed_editor_settings = res.editor_settings
                this.setState({
                    isJodit: parsed_editor_settings?.email_templates === 'jodit',
                    clientLogoUrl: res.client_logo_selected,
                    clientLogos: res.client_logos
                })
            })
            this.props.actions.getAvailabeEmails((res) => {
                this.setState({availableEmails: res})
            })
        }

        $('body').css('overflow-y', 'scroll');
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showHtmlModal !== this.state.showHtmlModal) {
            this.updateJoditConfig();
        }
    }

    onEditorStateChange = (editorState) => {
        let {resource} = this.state;
        resource.message = editorState;
        this.setState(resource);
        this.setState({client: this.state.client});
    };

    handleSelect = e => {
        this.setState({resource: merge(e.resource, this.defaultValues), initialValue: e.resource?.message});
        this.validateEmail('from', e.resource.from)
        this.validateEmail('reply_to', e.resource.reply_to)
        this.validateEmail('bcc', e.resource.bcc)

        const contentBlock = htmlToDraft(e.resource.message || '');
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({editorState})
    };

    reloadResources = () => {
        this.props.actions.load({}, this.updateResources);
    };


    setInnerHTML = (text) => {
        const { clientLogos } = this.state;
        let processedText = text;

        if (clientLogos) {
            for (const [size, url] of Object.entries(clientLogos)) {
                const shortcode = `{{client_logo.${size}}}`;
                const imgTag = url ? `<img src="${url}" style="max-width: 650px; height: auto" alt="logo" />` : shortcode;
                processedText = processedText.split(shortcode).join(imgTag);
            }
        }

        return <div dangerouslySetInnerHTML={{__html: processedText}}/>
    }

    validateEmail = (field, value) => {
        const { availableEmails } = this.state;

        if (
            value === null ||
            value === undefined ||
            value === ''
        ) {
            this.setState(prevState => {
                const updatedEmailErrors = {
                    ...prevState.emailErrors,
                    [`${field}EmailError`]: null
                };

                this.props.onValidationErrorChange?.(updatedEmailErrors);

                return { emailErrors: updatedEmailErrors };
            });
            return;
        }

        let error = null;

        if (Array.isArray(value)) {
            const invalidEmails = value
                .map(v => v.email)
                .filter(email => !availableEmails.includes(email));

            if (invalidEmails.length > 0) {
                error = `Email not allowed: ${invalidEmails.join(', ')}`;
            }
        } else {
            if (!availableEmails.includes(value)) {
                error = 'Email not allowed';
            }
        }

        this.setState(prevState => {
            const updatedEmailErrors = {
                ...prevState.emailErrors,
                [`${field}EmailError`]: error
            };

            this.props.onValidationErrorChange?.(updatedEmailErrors);

            return { emailErrors: updatedEmailErrors };
        });
    };

    ai_request = (request, respondWith) => {
        const openAiOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${config.tinyMceKey}`
            },
            body: JSON.stringify({
                model: 'gpt-4o',
                temperature: 0.7,
                max_tokens: 800,
                messages: [{role: 'user', content: request.prompt}],
            })
        };
        respondWith.string((signal) => window.fetch('https://api.openai.com/v1/chat/completions', {signal, ...openAiOptions})
            .then(async (response) => {
                if (response) {
                    const data = await response.json();
                    if (data.error) {
                        const err = new Error(`${data.error.type}: ${data.error.message}`);
                        this.props.actions.reportAiError(err);
                        throw err;
                    } else if (response.ok) {
                        return data?.choices[0]?.message?.content?.trim();
                    }
                } else {
                    const err = new Error('Failed to communicate with the ChatGPT API');
                    this.props.actions.reportAiError(err);
                    throw err;
                }
            })
        );
    };

    render() {
        const {
            resource,
            resources,
            isPreviewModalOpened,
            textMessageTemplateOptions,
            showHtmlModal,
            isJodit,
            shortcodesLoading,
            shortcodes
        } = this.state;
        const subscriptionOptions = Number(this.props.clientId) === 97 ? ['subscription created', 'subscription updated', 'subscription deleted', 'subscription paid', 'subscription payment failed'] : [];
        const options = optionsFor('sticky', 'proposal', 'proposal confirmation auto email', 'proposal decline auto email', 'scheduler_event', 'invoice', 'arborist proposal confirmation', 'arborist message confirmation', 'customer message confirmation', 'issue', 'issue change', 'payment', 'embedded', 'customer payment request', 'arborist payment request', 'payment notification', 'crew message', 'work order completed', 'service completed', 'rejected email', ...subscriptionOptions, 'technician email', 'backlog proposal services', 'daily briefing', 'service priority', 'invitation', 'request password change', 'charge failed', 'credentials request', 'truck payment', 'lead duplicate', 'job completed', 'customer feedback', 'google review', 'invoice paid', 'download notification', 'checklist reminder', 'deposit', 'deposit notification');

        return (
            resources ? <MasterDetail
                resourceName="Email template"
                resourceNamePlural="Email templates"
                withToggle={true}
                toggleData={{
                    value: isJodit,
                    onChange: () => {
                        this.setState({isJodit: !isJodit});
                        this.props.actions.saveEditorSettings(
                            JSON.stringify({place: "email_templates", value: !isJodit ? "jodit" : "tinyMce"}),
                            this.props.clientId
                        )
                    },
                    labelLeft: "TinyMCE",
                    labelRight: "Jodit"
                }}
                resources={resources}
                resource={resource}
                select={this.handleSelect}
                save={() => this.props.actions.save({
                    ...resource,
                    message: updateExternalLinks("prod", resource.message)
                }, this.reloadResources)}
                delete={() => this.props.actions.remove(resource, x => {
                    this.setState({resource: null}, () => this.props.actions.load({}, this.updateResources));
                })}>
                {resource && <div>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    Name
                                </ControlLabel>
                                <FormControl
                                    name="name"
                                    onChange={this.updateResourceAttr}
                                    value={resource.name}
                                    onBlur={this.updateResourceAttrWithTrim}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Default for</ControlLabel>
                                <Select className="Select" classNamePrefix="select"
                                        value={select(options, resource.default_for)}
                                        isClearable={true}
                                        options={options}
                                        onChange={this.selectResourceAttr('default_for')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    From
                                </ControlLabel>
                                <FormControl
                                    name="from"
                                    placeholder="Default is user email"
                                    onChange={this.updateResourceAttr}
                                    value={resource.from}
                                    onBlur={(e) => {
                                        this.updateResourceAttrWithTrim(e)
                                        this.validateEmail('from', resource.from)
                                    }}
                                />
                                {this.state.emailErrors.fromEmailError && (
                                    <span className='error'>{this.state.emailErrors.fromEmailError}</span>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Text message</ControlLabel>
                                <Select className="Select" classNamePrefix="select"
                                        value={select(textMessageTemplateOptions, resource.text_message_template_id)}
                                        options={textMessageTemplateOptions}
                                        onChange={this.selectResourceAttr('text_message_template_id')}
                                        isClearable
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    Reply to
                                </ControlLabel>
                                <FormControl
                                    name="reply_to"
                                    placeholder="Default is user email"
                                    onChange={this.updateResourceAttr}
                                    value={resource.reply_to}
                                    onBlur={(e) => {
                                        this.updateResourceAttrWithTrim(e)
                                        this.validateEmail('reply_to', resource.reply_to)
                                    }}
                                />
                                {this.state.emailErrors.reply_toEmailError && (
                                    <span className='error'>{this.state.emailErrors.reply_toEmailError}</span>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>Validate shortcodes for</ControlLabel>
                                <Select className="Select" classNamePrefix="select"
                                        value={select(validateShortcodesOptions, resource.validate_shortcodes_for)}
                                        options={validateShortcodesOptions}
                                        onChange={this.selectResourceAttr('validate_shortcodes_for')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    BCC
                                </ControlLabel>
                                <FormControl
                                    name="bcc"
                                    placeholder="Default is user email"
                                    onChange={this.updateResourceAttr}
                                    value={resource.bcc}
                                    onBlur={(e) => {
                                        this.updateResourceAttrWithTrim(e);
                                        this.validateEmail('bcc', resource.bcc_recipients);
                                    }}
                                />
                                {this.state.emailErrors.bccEmailError && (
                                    <span className='error'>{this.state.emailErrors.bccEmailError}</span>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <ControlLabel>
                                    Subject
                                </ControlLabel>
                                <FormControl
                                    name="subject"
                                    onChange={this.updateResourceAttr}
                                    value={resource.subject}
                                    onBlur={this.updateResourceAttrWithTrim}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <EmailEditorPreview
                            title="Preview mode"
                            show={isPreviewModalOpened}
                            onHide={() => this.setState({isPreviewModalOpened: !isPreviewModalOpened})}
                            closeButton={() => this.setState({isPreviewModalOpened: !isPreviewModalOpened})}
                        >
                            <p className="line_height15">{this.setInnerHTML(resource.message)}</p>
                        </EmailEditorPreview>
                        <Col md={12} className={"jodit-container-col"}>
                            <FormGroup>
                                <div className="space-between">
                                    <ControlLabel>
                                        Message
                                    </ControlLabel>
                                    {isJodit && <div className="d-flex">
                                        <MaterialSwitch
                                            value={showHtmlModal}
                                            onChange={() => this.setState({showHtmlModal: !showHtmlModal})}
                                            label="Show HTML Modal"
                                        />
                                    </div>}
                                </div>
                                {isJodit ? <JoditEditor
                                    editorRef={this.setRef}
                                    value={updateExternalLinks(null, resource.message)}
                                    config={this.state.config}
                                    onChange={(newValue) => this.onEditorStateChange(newValue)}
                                    onBlur={(newValue) => this.onEditorStateChange(newValue)}
                                /> : <div ref={this.wrapperRef}>
                                    {!shortcodesLoading && <Editor
                                        key={this.state.resource.validate_shortcodes_for}
                                        apiKey={config.tinyMceKey}
                                        onInit={(evt, editor) => {
                                            this.editorRef.current = editor
                                            const sink = document.querySelector(".tox-silver-sink ")

                                            if (sink && this.wrapperRef.current) {
                                                this.wrapperRef.current.appendChild(sink)
                                            }
                                        }}
                                        initialValue={this.state.initialValue}
                                        value={updateExternalLinks(null, resource.message)}
                                        onEditorChange={(newValue) => this.onEditorStateChange(newValue)}
                                        init={{
                                            convert_urls: false,
                                            automatic_uploads: false,
                                            paste_data_images: true,
                                            height: 500,
                                            extended_valid_elements: 'svg[*],path[*]',
                                            valid_children: '+body[style]',
                                            menubar: 'file edit insert view format table tools help',
                                            plugins: [
                                                'ai', 'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
                                                'tinymcespellchecker'
                                            ],
                                        toolbar: 'undo redo | aidialog aishortcuts | blocks | ' +
                                                  'bold italic forecolor | alignleft aligncenter ' +
                                                  'alignright alignjustify | bullist numlist outdent indent | ' +
                                                  'removeformat | spellchecker | help | shortcodes | preview',
                                            spellchecker_language: 'en_US',
                                            toolbar_mode: 'wrap',
                                            ai_request: this.ai_request,
                                            mobile: {
                                                convert_urls: false,
                                                menubar: true,
                                               toolbar_mode: 'wrap',
                                                 plugins: [
                                                     'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'ai', 'tinymcespellchecker'
                                                ],
                                            },
                                            setup: (editor) => {
                                                const filterShortcodesKeys = shortcodeOptions[this.state.resource.validate_shortcodes_for]
                                                const items = shortcodes.filter(s => {
                                                    if (this.state.resource.validate_shortcodes_for === "other (No validation)" || !this.state.resource.validate_shortcodes_for) {
                                                        return true
                                                    }
                                                    return filterShortcodesKeys?.includes(s.accessor) || s.accessor === "signature"
                                                }).map(({template_name, accessor, entries}) => {
                                                    const isEntriesArray = Array.isArray(entries);
                                                    const entriesChecked = isEntriesArray ? entries[0] : entries
                                                    const formatted = [];
                                                    Object.keys(entriesChecked).forEach((key) => {
                                                        const value = entriesChecked[key];
                                                        if (Array.isArray(value)) {
                                                            if (value.length === 1) {
                                                                const nestedKeys = Object.keys(value[0])
                                                                nestedKeys.forEach(nestedKey => {
                                                                    if (Array.isArray(value[0][nestedKey])) {
                                                                        const nestedArray = value[0][nestedKey]
                                                                        if (nestedArray.length === 1) {
                                                                            const nestedArrayKeys = Object.keys(nestedArray[0])
                                                                            formatted.push({
                                                                                key: `${key}--${nestedKey}`,
                                                                                type: "array",
                                                                                value: nestedArrayKeys
                                                                            })
                                                                        }
                                                                    }
                                                                })
                                                                formatted.push({key, type: "array", value: nestedKeys})
                                                            } else {
                                                                formatted.push({key, type: "array", value: []})
                                                            }
                                                        } else {
                                                            formatted.push({key, type: "normal"})
                                                        }
                                                    });

                                                    return {
                                                        type: Object.keys(entries).length === 0 ? 'menuitem' : 'nestedmenuitem',
                                                        text: isEntriesArray ? `${template_name} [List]` : template_name,
                                                        getSubmenuItems: () => _.sortBy(formatted, "key").filter(f => !f.key.includes("--")).map(item => {
                                                            if (item.type === "array") {
                                                                const nestedKeys = item.value
                                                                return {
                                                                    type: 'nestedmenuitem',
                                                                    text: `${item.key} [List]`,
                                                                    getSubmenuItems: () => [{
                                                                        type: 'menuitem',
                                                                        text: `${item.key} Wrapper`,
                                                                        onAction: () => editor.insertContent(`{% for ${item.key[0]} in ${accessor}.${item.key} %}{{${item.key[0]}.sample_field <= change this}}{% endfor %}`),
                                                                    }, ...nestedKeys.sort().map(nestedItem => {
                                                                        const deepNested = formatted.find(f => f.key === `${item.key}--${nestedItem}`)
                                                                        if (deepNested) {
                                                                            return {
                                                                                type: 'nestedmenuitem',
                                                                                text: nestedItem,
                                                                                getSubmenuItems: () => [{
                                                                                    type: 'menuitem',
                                                                                    text: `${nestedItem} Wrapper`,
                                                                                    onAction: () => editor.insertContent(`{% for ${nestedItem[0]} in ${item.key[0]}.${nestedItem} %}{{${nestedItem[0]}.sample_field <= change this}}{% endfor %}`),
                                                                                }, ...deepNested.value.map(deepNestedItem => {
                                                                                    return {
                                                                                        type: 'menuitem',
                                                                                        text: deepNestedItem,
                                                                                        onAction: function () {
                                                                                            editor.insertContent(`{{${nestedItem[0]}.${deepNestedItem}}}`)
                                                                                        }
                                                                                    }
                                                                                })],
                                                                            }
                                                                        }

                                                                        return {
                                                                            type: 'menuitem',
                                                                            text: nestedItem,
                                                                            onAction: function () {
                                                                                editor.insertContent(`{{${item.key[0]}.${nestedItem}}}`)
                                                                            }
                                                                        }
                                                                    })]
                                                                }
                                                            }
                                                            return {
                                                                type: 'menuitem',
                                                                text: item.key,
                                                                onAction: function () {
                                                                    editor.insertContent(`{{${accessor}.${item.key}}}`)
                                                                }
                                                            }
                                                        }),
                                                        onAction: function () {
                                                            editor.insertContent(`{{${accessor}}}`)
                                                        }

                                                    }
                                                })
                                                const controlFlowItems = [
                                                     {
                                                         type: 'nestedmenuitem',
                                                         text: 'If Conditional',
                                                         getSubmenuItems: () => [
                                                             {
                                                                 type: 'menuitem',
                                                                 text: 'if / endif',
                                                                 onAction: () => editor.insertContent('{% if condition <= change this %}content here{% endif %}')
                                                             },
                                                             {
                                                                 type: 'menuitem',
                                                                 text: 'if / else / endif',
                                                                 onAction: () => editor.insertContent('{% if condition <= change this %}content if true{% else %}content if false{% endif %}')
                                                             },
                                                             {
                                                                 type: 'menuitem',
                                                                 text: 'if / elsif / else / endif',
                                                                 onAction: () => editor.insertContent('{% if condition1 <= change this %}content 1{% elsif condition2 <= change this %}content 2{% else %}content default{% endif %}')
                                                             }
                                                         ]
                                                     }
                                                 ];
                                                 editor.ui.registry.addMenuButton('shortcodes', {
                                                     text: 'Shortcodes',
                                                     fetch: (callback) => {
                                                         callback(controlFlowItems.concat(items));
                                                     }
                                                 })
                                                 editor.ui.registry.addButton('preview', {
                                                     text: 'Preview',
                                                     icon: 'preview',
                                                     tooltip: 'Preview email',
                                                     onAction: () => this.setState({isPreviewModalOpened: true})
                                                 })
                                             }
                                        }}
                                    />}
                                </div>}
                            </FormGroup>
                        </Col>
                    </Row></div>
                }
            </MasterDetail> : null);
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...actions, saveEditorSettings, getClient}, dispatch),
});

const EmailTemplatesWithMedia = withMediaQuery(EmailTemplates, {
    isMobile: { maxWidth: 767 },
});

export default connect(undefined, mapDispatchToProps)(EmailTemplatesWithMedia)
